import './modal.css';
import axios from "axios";
import styled from 'styled-components'

import { Tooltip } from 'react-tooltip'
import { NavLink, Link, useParams } from "react-router-dom";

import React, { useState, useEffect, useCallback, useRef } from 'react';

import { useTranslation } from 'react-i18next';

const Styles = styled.div`
  --section-color: var(--fire);
  line-height: 150%;
  font-size: 18px;

  h2: {
    font-size: 30px;
  }
`;

const symbols = {
  Kategorien: <img width="48" alt="Kategorien" src="/Kategorien.svg" />,
  Unterorte: <img width="48" alt="Unterorte" src="/Unterorte.svg" />,
  Zusatzorte: <img width="48" alt="Zusatzorte" src="/Zusatzorte.svg" />,
  Hotel: <img width="48" alt="Hotel" src="/Hotel.svg" />,
  Reisezeit: <img width="48" alt="Reisezeit" src="/Reisezeit.svg" />,
  Ausgangsort: <img width="48" alt="Ausgangsort" src="/Ausgangsort.svg" />,
  UN1:
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="8" fill="#E74011"></rect>
      <text x="50%" y="50%" font-family="Arial, sans-serif" font-size="18" fill="white" text-anchor="middle" dominant-baseline="central">UN</text>
    </svg>,
  UN2:
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="8" fill="#E74011"></rect>
      <text x="50%" y="50%" font-family="Arial, sans-serif" font-size="18" fill="white" text-anchor="middle" dominant-baseline="central">(UN)</text>
    </svg>,
}

function Property({ type, t, highlight, children }) {
  if (highlight[type] === null)
    return <></>;
  return <>
    <div style={{ display: "flex", flexDirection: "row" }}>
      <div style={{ paddingRight: "10px", minWidth: "50px" }}>
        {symbols[type]}
      </div>
      <div>
        <p className="highlightviewtitle">{t(`texts.highlight.${type}`)}:</p>
        <p className="highlightview">
          {children === undefined ? highlight[type] : children}
        </p>
      </div>
    </div>
    <div className="thin-line"></div>
  </>
}

const HighlightModal = (props) => {
  const [highlight, setEvent] = useState(undefined);
  const [map, setMap] = useState(false)

  const modalRef = useRef(null);
  const isFirstRender = useRef(true);

  const { lang } = useParams();
  const { t, i18n } = useTranslation();
  // Change the language dynamically
  React.useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang, i18n]);

  const checkMap = function () {
    if (window.UC_UI && window.UC_UI.isInitialized()) {
      window.UC_UI.getServicesBaseInfo().forEach(service => {
        if (service.id === "S1pcEj_jZX" && service.consent.status) {
          setMap(true)
        }
      })
      return true;
    }
    return false;
  }

  React.useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;  // Mark first render as complete
      window.addEventListener('UC_UI_CMP_EVENT', checkMap);
      if (checkMap() === false) {
        console.log("Map: Adding timer");
        setTimeout(() => {
          checkMap();
        }, 3000);
      }
    }
  }, []);

  useEffect(() => {
    // Call the data loading function when component mounts

    if (props.eventId === undefined || props.eventId === -1)
      return;
    var url = `${process.env.REACT_APP_DATA_HOST}/${props.lang}/event`
    if (props.checkingMode === true)
      url += "_check"
    axios.get(url + "/" + props.eventId).then(res => {
      const highlight = res.data.data[0];
      // console.log(highlight);
      setEvent(highlight);
      highlight.Details = highlight.Details.replace(/\r\n|\r|\n/g, "<br />");
      highlight.Details = highlight.Details.replace(/\*(.*?)\*/g, "<strong>$1</strong>");
      // console.log(highlight.Details)
      if (props.checkingMode && highlight !== undefined) {
        if (highlight.de === null || highlight.status > 0) {
          props.navigate(props.listPath + props.navigateURL(props.eventId, 1))
        }
      }
      if (modalRef.current) {
        modalRef.current.scrollTo({ top: 0, behavior: "smooth" });
      }
    })
    checkMap();
  }, [props]); // Dependencies array triggers re-run when these change

  const updateStatus = useCallback((new_status) => {
    axios.put(`${process.env.REACT_APP_DATA_HOST}/set_status/` + props.eventId + '/' + new_status).then(res => {
      props.navigate(props.listPath + props.navigateURL(props.eventId, 1))
    })
  }, [props]);

  useEffect(() => {
    const escFunction = event => {
      if (!props.show)
        return;

      if (event.key === "Escape") {
        props.navigate(props.listPath)
      }
      if (event.key === "ArrowRight") {
        props.navigate(props.listPath + props.navigateURL(props.eventId, 1))
      }
      if (event.key === "ArrowLeft") {
        props.navigate(props.listPath + props.navigateURL(props.eventId, -1))
      }

      if (!props.checkingMode)
        return;

      if (event.key === "Enter") {
        updateStatus(1)
      }
      if (event.key === "w") {
        updateStatus(2)
      }

      // console.log(event.key)
    }

    // Add the event listener
    document.addEventListener("keydown", escFunction);

    // Cleanup function to remove the event listener on unmount
    return () => {
      document.removeEventListener("keydown", escFunction);
    };
  }, [props, updateStatus]); // Dependency array ensures this only runs once and cleans up properly

  const googlemap = highlight => {
    var q = highlight.Ausgangsort.replace(/\s?\(.*\)/, "");
    if (q.lastIndexOf("/ ") > 0)
      q = q.substr(q.lastIndexOf("/ ") + 2);
    if (q.lastIndexOf("/") > 0)
      q = q.substr(q.lastIndexOf("/") + 1);
    q += "," + highlight.Land;
    q = q.replaceAll(", DC", ", D.C."); // special case for Washington, DC
    q = q.replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "+");
    // console.log(q);
    return q;
  }

  return (
    <Styles className={props.show ? "modal display-block" : "modal display-none"}>
      <section className="modal-main" ref={modalRef}>
        {highlight !== undefined && props.checkingMode === false &&
          <>
            <div style={{
              position: "sticky",
              top: 0,
              background: "white",
              zIndex: 1001,
              padding: "40px 40px 0px 40px",
            }}>
              <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                <h2>{highlight.Beschreibung}</h2>

                <div style={{ minWidth: "150px", flexShrink: "0" }}>
                  <NavLink to={props.listPath + props.navigateURL(props.eventId, -1)} style={{ minWidth: "48px", paddingRight: "2px" }}>
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="48" height="48" rx="8" fill="#E74011"></rect>
                      <path fillRule="evenodd" clipRule="evenodd" d="M12 24L36 39L36 9Z" fill="white"></path>
                    </svg>
                  </NavLink>
                  <NavLink to={props.listPath} style={{ minWidth: "48px", paddingRight: "2px" }}>
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="48" height="48" rx="8" fill="#E74011"></rect>
                      <path d="M14 14L34 34M14 34L34 14" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"></path>
                    </svg>
                  </NavLink>
                  <NavLink to={props.listPath + props.navigateURL(props.eventId, 1)} style={{ minWidth: "48px", paddingRight: "2px" }}>
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="48" height="48" rx="8" fill="#E74011"></rect>
                      <path fillRule="evenodd" clipRule="evenodd" d="M36 24L12 39L12 9Z" fill="white"></path>
                    </svg>
                  </NavLink>
                </div>
              </div>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "begin" }}>
              <div style={{ paddingRight: "40px", paddingLeft: "40px", width: "40%", flexGrow: "1" }}>
                <div dangerouslySetInnerHTML={{__html: highlight.Details}}></div>
                <br />
              </div>
              <div style={{ width: "400px", paddingTop: "0px", paddingLeft: "40px", paddingRight: "40px" }}>
                <div>
                  <table>
                    <tbody>
                      <tr><td className="geodata-title">{t('texts.highlight.kontinent')}</td><td className="geodata-text">{highlight.Kontinent}</td></tr>
                      <tr><td className="geodata-title">{t('texts.highlight.kontregion')}</td><td className="geodata-text">{highlight.KontRegion}</td></tr>
                      <tr><td className="geodata-title">{t('texts.highlight.land')}</td><td className="geodata-text">{highlight.Land}</td></tr>
                      <tr><td className="geodata-title">{t('texts.highlight.landregion')}</td><td className="geodata-text">{highlight.LandRegion}</td></tr>
                    </tbody>
                  </table>
                </div>
                <div style={{ height: "2rem" }}></div>
                <div className="thin-line"></div>
                <Property t={t} type="Kategorien" highlight={highlight}>
                  {highlight.Kategorie1} {highlight.Kat1Rang !== null && <>(Rang {highlight.Kat1Rang}) </>}
                  {highlight.Kategorie2 !== null && <>| {highlight.Kategorie2}</>} {highlight.Kat2Rang !== null && <>(Rang {highlight.Kat2Rang}) </>}
                  {highlight.Kategorie3 !== null && <>| {highlight.Kategorie3}</>} {highlight.Kat3Rang !== null && <>(Rang {highlight.Kat3Rang}) </>}
                  {highlight.Kategorie4 !== null && <>| {highlight.Kategorie4}</>} {highlight.Kat4Rang !== null && <>(Rang {highlight.Kat4Rang}) </>}
                </Property>
                {highlight.WEL_Nr !== null && highlight.WEL_Orig === 1 &&
                  <Property t={t} type="UN1" highlight={highlight}>
                    {highlight.WEL_Name} (Nr. {highlight.WEL_Nr})
                  </Property>
                }
                {highlight.WEL_Nr !== null && highlight.WEL_Orig !== 1 &&
                  <Property t={t} type="UN2" highlight={highlight}>
                    {highlight.WEL_Name}(Nr. {highlight.WEL_Nr}){' '}
                    <Tooltip id="unesco">{t('texts.highlight.UNTooltip')}</Tooltip>
                    <NavLink data-tooltip-id="unesco" target="_blank"
                      to={{ pathname: `${props.basePath + "/unescolist"}`, search: `${"?WEL_Nr=" + highlight.WEL_Nr}` }}>{t('texts.highlight.UNAll')}</NavLink>
                  </Property>
                }
                <Property t={t} type="Ausgangsort" highlight={highlight} />
                <Property t={t} type="Unterorte" highlight={highlight} />
                <Property t={t} type="Zusatzorte" highlight={highlight} />
                <Property t={t} type="Hotel" highlight={highlight} />
                <Property t={t} type="Reisezeit" highlight={highlight} />
                <div style={{ height: "2rem" }}></div>
                <div>
                  {(map) ?
                    <>
                      <iframe title="googlemap" style={{ width: 400, height: 300, border: 0 }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyCf0QT1eh6vDvzDPi-GffF43dAX3mVD2CM&zoom=4&language=${props.lang}&q=` + googlemap(highlight)} />
                      <Link target="_blank" rel="noopener noreferrer" to={"https://www.google.com/maps/search/" + googlemap(highlight)}>
                        <button className='highlight-button'>{t('texts.highlight.map_external')}</button>
                      </Link>
                    </>
                    :
                    <div>
                      {t('texts.highlight.nomap')}<br />
                      <button className='highlight-button' onClick={() => { window.UC_UI.showSecondLayer() }}>{t('texts.highlight.nomap_cookie')}</button>
                      {' '}
                      <Link target="_blank" rel="noopener noreferrer" to={"https://www.google.com/maps/search/" + googlemap(highlight)}>
                        <button className='highlight-button'>{t('texts.highlight.nomap_external')}</button>
                      </Link>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div style={{
              background: "white",
              padding: "40px 40px 40px 40px",
            }}>
              <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                <NavLink to={props.listPath + props.navigateURL(props.eventId, -1)}><button className='highlight-button'>{t('texts.highlight.prev')}</button></NavLink>
                <NavLink to={props.listPath}><button className='highlight-button'>{t('texts.highlight.close')}</button></NavLink>
                <NavLink to={props.listPath + props.navigateURL(props.eventId, 1)}><button className='highlight-button'>{t('texts.highlight.next')}</button></NavLink>
              </div>
            </div>
          </>
        }
        {highlight !== undefined && props.checkingMode === true &&
          <>
            <table width="100%">
              <tbody>
                <tr>
                  <td><NavLink to={props.listPath + props.navigateURL(props.eventId, -1)}><button type="button">Vorheriges Highlight</button></NavLink></td>
                  <td align="center">
                    <button type="button" style={{ color: "green" }} onClick={() => updateStatus(1)}>OK --> RETURN</button>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <button type="button" style={{ color: "red" }} onClick={() => updateStatus(2)}>WRONG --> W</button>
                  </td>
                  <td align="right"><NavLink to={props.listPath + props.navigateURL(props.eventId, 1)}><button type="button">N&auml;chstes Highlight</button></NavLink></td>
                </tr>
              </tbody>
            </table>
            <p>Id {highlight.auto} Status: {highlight.status === 1 ? "OK" : highlight.status === 2 ? "WRONG" : "n/a"}</p>
            <p><b>{highlight.Höhepunkt}</b> in {highlight.Land} ({highlight.LandRegion})
              auf dem Kontinent {highlight.Kontinent} ({highlight.KontRegion})</p>
            <p>Original: <i>{highlight.EinzKrit}</i></p>
            <p>DE: <i>{highlight.de}</i></p>
            <p>EN: <i>{highlight.en}</i></p>
            <p>Kategorien: {highlight.Kategorie1} {highlight.Kat1Rang !== null && <>(Rang {highlight.Kat1Rang})</>}
              {highlight.Kategorie2 !== null && <>| {highlight.Kategorie2}</>} {highlight.Kat2Rang !== null && <>(Rang {highlight.Kat2Rang}) </>}
              {highlight.Kategorie3 !== null && <>| {highlight.Kategorie3}</>} {highlight.Kat3Rang !== null && <>(Rang {highlight.Kat3Rang}) </>}
              {highlight.Kategorie4 !== null && <>| {highlight.Kategorie4}</>} {highlight.Kat4Rang !== null && <>(Rang {highlight.Kat4Rang}) </>}
            </p>
            <table width="100%">
              <tbody>
                <tr>
                  <td><NavLink to={props.listPath + props.navigateURL(props.eventId, -1)}><button type="button">Vorheriges Highlight</button></NavLink></td>
                  <td align="center"><NavLink to={props.listPath}><button type="button">Schlie&szlig;en</button></NavLink></td>
                  <td align="right"><NavLink to={props.listPath + props.navigateURL(props.eventId, 1)}><button type="button">N&auml;chstes Highlight</button></NavLink></td>
                </tr>
              </tbody>
            </table>
          </>
        }
        {highlight === undefined &&
          <p>Loading...</p>
        }
      </section>
    </Styles>
  );
}

export default HighlightModal;